import api from './client';

// 桌面端本地语音输入：开源 ASR 模型管理 + 离线识别（后端 sherpa-onnx）

export interface SpeechModel {
  id: string;
  name: string;
  desc: string;
  size_bytes: number;
  downloaded: boolean;
  download?: {
    status: 'downloading' | 'done' | 'error';
    percent: number;
    downloaded: number;
    total: number;
    error?: string | null;
  } | null;
}

export const listSpeechModels = () =>
  api.get<{ models: SpeechModel[] }>('/api/v1/speech/models').then((r) => r.data.models);

export const startSpeechModelDownload = (modelId: string) =>
  api.post(`/api/v1/speech/models/${modelId}/download`).then((r) => r.data);

export const transcribeAudio = (wav: Blob, modelId?: string) => {
  const form = new FormData();
  form.append('file', wav, 'voice.wav');
  if (modelId) form.append('model_id', modelId);
  return api
    .post<{ text: string; model_id: string | null }>('/api/v1/speech/transcribe', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 180000,
    })
    .then((r) => r.data);
};
